export const SOCKET_URL = " wss://52dyigt40h.execute-api.eu-west-1.amazonaws.com/dev1";
